<template>
  <div v-if="show">
    <div class="modal fade show confirm-action-modal" tabindex="-1" aria-modal="true" role="dialog" style="display: block;">
      <div class="modal-dialog modal-md modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">{{ title }}</h4>
            <button class="btn-close" type="button" aria-label="Close" @click="$emit('cancel')"></button>
          </div>

          <div class="modal-body">
            <p class="confirm-action-message">{{ message }}</p>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-light" @click="$emit('cancel')">
              {{ cancelText }}
            </button>
            <button type="button" class="btn btn-primary" @click="$emit('confirm')">
              {{ confirmText }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmActionModal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Confirmar acción',
    },
    message: {
      type: String,
      default: '¿Deseas continuar con esta acción?',
    },
    confirmText: {
      type: String,
      default: 'Confirmar',
    },
    cancelText: {
      type: String,
      default: 'Cancelar',
    },
  },
};
</script>
